import React, { FC } from 'react';
import { FiDownload } from 'react-icons/fi';
import { Props } from './types';
import { Container, Content, Wrap, Date, DownloadLink } from './styles';

const Row: FC<Props> = ({ row }) => {
  return (
    <Container>
      <Content>
        <Wrap>
          <Date>{row.createdLocalised}</Date>
        </Wrap>
        <Wrap>
          <Date>{row.startDate}</Date>
        </Wrap>
        <Wrap>
          <Date>{row.endDate}</Date>
        </Wrap>
        <Wrap>
          <DownloadLink>
            <a
              href={row.fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              download={`${row.orgId}-${row.created}.pdf`}
            >
              <FiDownload />
            </a>
          </DownloadLink>
        </Wrap>
      </Content>
    </Container>
  );
};

export default Row;
